/*
Copyright (c) 2020-present NAVER Corp.
name: @egjs/vue-view3d
license: MIT
author: NAVER Corp.
repository: https://github.com/naver/egjs-view3d/tree/master/packages/vue-view3d
version: 2.2.1
*/
import Vue from 'vue';
import VanillaView3D, { withMethods, getValidProps, EVENTS, DEFAULT_CLASS } from '@egjs/view3d';
export * from '@egjs/view3d';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var view3DOptionNames = Object.getOwnPropertyNames(VanillaView3D.prototype).filter(function (name) {
  var descriptor = Object.getOwnPropertyDescriptor(VanillaView3D.prototype, name);
  if (name.startsWith("_")) return false;
  if (descriptor === null || descriptor === void 0 ? void 0 : descriptor.value) return false;
  return true;
});
var view3DOptions = view3DOptionNames.reduce(function (props, name) {
  var _a;

  return __assign(__assign({}, props), (_a = {}, _a[name] = null, _a));
}, {});
var view3DSetterNames = view3DOptionNames.filter(function (name) {
  var descriptor = Object.getOwnPropertyDescriptor(VanillaView3D.prototype, name);
  return !!descriptor.set;
});
var View3D = Vue.extend({
  props: __assign(__assign({}, view3DOptions), {
    tag: {
      type: String,
      required: false,
      default: "div"
    },
    canvasClass: {
      type: String,
      required: false,
      default: ""
    }
  }),
  created: function () {
    withMethods(this, "_view3D");
  },
  mounted: function () {
    var _this = this;

    var props = getValidProps(this.$props);
    this._view3D = new VanillaView3D(this.$refs.wrapper, props);
    var events = Object.keys(EVENTS).map(function (key) {
      return EVENTS[key];
    });
    events.forEach(function (eventName) {
      _this._view3D.on(eventName, function (e) {
        e.target = _this; // Make events from camelCase to kebab-case

        _this.$emit(eventName.replace(/([A-Z])/g, "-$1").toLowerCase(), e);
      });
    });
  },
  beforeDestroy: function () {
    var _a;

    (_a = this._view3D) === null || _a === void 0 ? void 0 : _a.destroy();
  },
  render: function (h) {
    var _a;

    var canvasClass = (_a = this.canvasClass) !== null && _a !== void 0 ? _a : "";
    var canvasClassName = (DEFAULT_CLASS.CANVAS + " " + canvasClass).trim();
    return h(this.tag, {
      ref: "wrapper",
      staticClass: DEFAULT_CLASS.WRAPPER
    }, [h("canvas", {
      staticClass: canvasClassName
    }), this.$slots.default]);
  },
  watch: __assign({}, view3DSetterNames.reduce(function (setters, name) {
    setters["$props." + name] = {
      handler: function (newVal) {
        if (!this._view3D) return;
        this._view3D[name] = newVal;
      },
      deep: true
    };
    return setters;
  }, {}))
});

var version = "2.2.1";

var install = function (Vue) {
  Vue.component("View3D", View3D);
};

var plugin = {
  View3D: View3D,
  install: install,
  version: version
};

export default plugin;
export { View3D, install, version };
//# sourceMappingURL=view3d.esm.js.map
